<span>
  {{ data }}
  <!--<button mat-button (click)="closeError()">OK</button>-->
</span>
